import React from "react";
import "./TextInput.css";
import CustomError from "../Errors/CustomError";
import Asterisks from "../Asterisks/Asterisks";

const TextInput = ({
  label,
  name,
  value = "",
  onChange,
  parentClassName = "",
  inputClassName = "",
  labelClassName = "",
  placeholder = "Enter text",
  parentStyle = {},
  inputStyle = {},
  labelStyle = {},
  maxLength,
  minLength,
  readOnly = false,
  disabled = false,
  required = false,
  spellcheck = false,
  size,
  pattern,
  autocomplete = "off",
  customError,
  asterisk,
  type = "text",
}) => {
  return (
    <div
      className={
        parentClassName && parentClassName.trim() !== ""
          ? parentClassName
          : "default-textinput-parent-class"
      }
      style={parentStyle}
    >
      <label
        style={labelStyle}
        className={
          labelClassName && labelClassName.trim() !== ""
            ? labelClassName
            : "default-textinput-label-class"
        }
      >
        {label} <Asterisks asterisk={asterisk} />
      </label>
      <div className="input-wrapper">
        <input
          name={name}
          type={type ?? "text"}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          className={`${inputClassName && inputClassName.trim() !== ""
              ? inputClassName
              : "default-textinput-input-class"
            } ${customError ? "input-error" : ""}`}
          style={{
            ...inputStyle, // Any other custom styles you want to pass
            backgroundColor: disabled || readOnly ? "lightgray" : "", // Set background color to light gray if disabled
          }}
          maxLength={maxLength}
          minLength={minLength}
          readOnly={readOnly}
          disabled={disabled}
          required={required}
          spellcheck={spellcheck}
          size={size}
          pattern={pattern}
          autoComplete={autocomplete}
        />
        {customError && (
          <i className="fas fa-exclamation-circle error-icon"></i>
        )}
      </div>
      {customError && <CustomError error={customError} />}
    </div>
  );
};

export default TextInput;